import {useCallback, useState} from 'react';

function useDelay(minimumDelay: number) {
    const [isPending, setIsPending] = useState(false);

    const delay = useCallback(async <T>(action: () => Promise<T>): Promise<T> => {
        setIsPending(true);
        const startTime = Date.now();
        let result: T;

        try {
            // Do some set of actions
            result = await action();
        } catch (error) {
            throw error; // Re-throw the error to let the caller handle it
        } finally {
            // Calculate elapsed time
            const elapsedTime = Date.now() - startTime;

            // Calculate remaining delay to ensure minimumDelay is respected
            const remainingDelay = minimumDelay - elapsedTime;

            // If there's still remaining time, wait for it
            if (remainingDelay > 0) {
                await new Promise(resolve => setTimeout(() => { resolve(result); }, remainingDelay));
            }

            setIsPending(false);
        }

        return result;
    }, [minimumDelay]);

    return {delay, isPending};
}

export {useDelay}